import { useEffect, useState } from "react";
import { Banner, PresenterCards } from "../components/index";
import { tracking } from '../utils/tracking';
import { imgs } from '../assets/imgs';
import { useResizeImg } from '../hooks/useResizeImg';
import { updateTags } from "../utils/funcs";

export const TopInnovators = () => {
    const [isLoading, setIsLoading] = useState(true);
    const imageSource = useResizeImg(imgs.topInovators.topInovatorsDesktop, imgs.startups.startupBannerMobile)

    useEffect(() => {
        updateTags("| Top Innovators")
    }, [])

    return (
        <div className='top-innovators'>
            <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
                <section >
                    <h1>Top Innovators</h1>
                </section>
                {/* <section>
                    <a className="btn" href='https://account.youngstartup.com' onClick={() => { tracking(369); }}>APPLY NOW</a>
                </section> */}
            </Banner>
            <PresenterCards />
        </div >
    )
}
